// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "collectives-" + chunkId + ".js?v=" + "c29a88b552adb0d38cb0" + "";
};